import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface ScrollBorderClasses {
	/** styles applied to the root element */
	root: string;
	hasOverflow: string;
	hasHorizontalOverflow: string;
	scrolled: string;
	scrolledHorizontally: string;
	scrolledToEnd: string;
	scrolledToEndHorizontally: string;
	scrollSentinel: string;

	disableHorizontalScroll: string;
	scrollBorder: string;
	scrollBorderBottom: string;
	scrollBorderRight: string;
	scrollBorderLeft: string;
	scrollBorderTop: string;
	scrollWrapper: string;
	scrollWrapperInner: string;
	scrollWrapperContent: string;
}

export const getScrollBorderUtilityClass = (slot: string) =>
	generateUtilityClass('ScrollBorder', slot);

export const scrollBorderClasses = generateUtilityClasses<
	keyof ScrollBorderClasses
>('ScrollBorder', [
	'root',
	'disableHorizontalScroll',
	'hasOverflow',
	'hasHorizontalOverflow',
	'scrolled',
	'scrolledHorizontally',
	'scrolledToEnd',
	'scrolledToEndHorizontally',
	'scrollBorder',
	'scrollBorderBottom',
	'scrollBorderLeft',
	'scrollBorderRight',
	'scrollBorderTop',
	'scrollSentinel',
	'scrollWrapper',
	'scrollWrapperContent',
	'scrollWrapperInner',
]);
export default scrollBorderClasses;
